module.exports = __webpack_public_path__ + "static/img/9.8af1eb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/9.jpg
// module id = pwbg
// module chunks = 1